import React from "react";
import window from "../lib/WindowExtended";
import {useTranslation} from "react-i18next";

interface ILoaderProps {
  isLoading?: boolean;
  error?: boolean;
  onRetry?: () => void;
}

const defaultRetry = () => {
  window.location.reload();
};

const LoadingSpinner: React.FC<ILoaderProps> = ({isLoading = true, error = false, onRetry = defaultRetry}) => {
  const {t} = useTranslation();

  if (error) {
    return (
      <div>
        {t("general.errorOccurred")}
        {". "}
        <span role="link" className="link" onClick={onRetry}>
          {t("general.retry")}
        </span>
      </div>
    );
  } else if (isLoading) {
    return (
      <div className="loader">
        {Array.from({length: 8}).map((_, index) => {
          return <div key={index} className="loader__dot" />;
        })}
      </div>
    );
  } else {
    return null;
  }
};

export default LoadingSpinner;
